import { PostgrestError } from '@supabase/supabase-js';

export interface ServiceResponse<T> {
  data: T | null
  error: PostgrestError | Error | null
}

export interface ServiceArrayResponse<T> {
  data: T[] | null
  error: PostgrestError | Error | null
}

export function handleServiceError(error: any): Error {
  if (error?.message?.includes('Failed to fetch') || error?.message?.includes('NetworkError')) {
    return new Error('Cannot connect to database. Your Supabase project may be paused or inactive. Please check your Supabase dashboard.')
  }
  return error instanceof Error ? error : new Error('An unexpected error occurred')
}

// Helper to convert snake_case to camelCase
export function toCamelCase<T>(obj: any): T {
  if (obj === null || obj === undefined) return obj
  if (Array.isArray(obj)) return obj.map(item => toCamelCase(item)) as any
  if (typeof obj !== 'object') return obj

  const converted: any = {}
  Object.keys(obj).forEach(key => {
    const camelKey = key.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase())
    converted[camelKey] = toCamelCase(obj[key])
  })
  return converted
}

// Helper to convert camelCase to snake_case
export function toSnakeCase(obj: any): any {
  if (obj === null || obj === undefined) return obj
  if (Array.isArray(obj)) return obj.map(item => toSnakeCase(item))
  if (typeof obj !== 'object') return obj

  const converted: any = {}
  Object.keys(obj).forEach(key => {
    const snakeKey = key.replace(/([A-Z])/g, '_$1').toLowerCase()
    converted[snakeKey] = toSnakeCase(obj[key])
  })
  return converted
}